import { ProtectionDetailsExclusions } from '../../models/protection-details/protection-details-exclusions.interface';

export const mockProtectionDetailsExclusions: ProtectionDetailsExclusions = {
  protectionDetailsExclusions: ['Exclusion 1', 'Exclusion 2', 'Exclusion 3'],
  protectionDetailsExclusionsTitle: 'Panel Title',
};
